import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Brand } from "../components/Brand";

export default function AdminLogin() {
  const nav = useNavigate();
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) nav("/admin");
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data);
      toast.success("Signed in");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-[#F1F5F9] p-8 sm:p-12">
      <div className="flex items-center justify-between">
        <Brand subtitle="Administrator" />
        <button onClick={() => nav("/")} className="flex items-center gap-1.5 text-sm text-[#1E293B]/60 hover:text-[#2563EB]">
          <ArrowLeft className="h-4 w-4" strokeWidth={1.5} /> Home
        </button>
      </div>
      <div className="flex flex-1 items-center justify-center">
        <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-[#E2E8F0] bg-white p-8">
          <h1 className="font-display text-3xl text-[#1E293B]">Admin sign in</h1>
          <p className="mt-1 text-sm text-[#1E293B]/60">Manage access codes, schedules and results.</p>
          <div className="mt-6 space-y-4">
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-[#1E293B]/50">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input"
                className="mt-2 w-full rounded-xl border border-[#E2E8F0] px-4 py-3 outline-none focus:border-[#2563EB] focus:ring-2 focus:ring-[#2563EB]/30" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-[#1E293B]/50">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input"
                className="mt-2 w-full rounded-xl border border-[#E2E8F0] px-4 py-3 outline-none focus:border-[#2563EB] focus:ring-2 focus:ring-[#2563EB]/30" />
            </div>
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-btn"
            className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-[#2563EB] px-6 py-3.5 font-semibold text-white transition-transform duration-200 hover:-translate-y-1 disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"} <ArrowRight className="h-4 w-4" />
          </button>
        </form>
      </div>
    </div>
  );
}
